/* eslint-disable */
import * as THREE from 'three'

// TODOHI  traverse an object tree - see raycaster recursiveFlag
// TODOHI  handle finding object by name to build candidate array?
// TODOHI  check hit object visibility - may need a specific per-object visibility function
// TODO    clear playId when mouse leaves canvas?
function Picker(canvasEl, gl, cb) {
    const that = this
    const raycaster = new THREE.Raycaster() // create once
    const coords = new THREE.Vector2() // create once
    let playId

    this.state = {
        enabled: true,
    }

    function pick(event) {
        if (!that.state.enabled) {
            return
        }

        // TODOHI  find by name; too hard coded to specific scene graph structure
        const field = gl.scene.children[6]
        let hits

        if (!field) {
            return
            // Didn't want to mess with this in production
            // throw new Error(
            //     'Could not find hits in WebGL. Likely an index mismatch'
            // )
        }

        hits = field.children[0].children.map((hit) => hit.children)

        hits = [].concat.apply([], hits)

        // TODO    not sure why clientX/Y wasn't working, but offsetX/y seems okay
        // var offsetX = 101,//0,
        //     offsetY = 276,//0,
        //     x = event.clientX - offsetX,
        //     y = event.clientY - offsetY;
        const x = event.offsetX
        const y = event.offsetY
        const normX = x / canvasEl.clientWidth
        const normY = y / canvasEl.clientHeight

        coords.x = normX * 2 - 1
        coords.y = normY * -2 + 1

        raycaster.setFromCamera(coords, gl.camera)

        // console.log(' ');
        // console.log('canvas - clientWidth: ' + canvasEl.clientWidth + ', clientHeight: ' + canvasEl.clientHeight);
        // console.log('event.clientX: ' + event.clientX + ', event.clientY: ' + event.clientY );
        // console.log('event.offsetX: ' + event.offsetX + ', event.offsetY: ' + event.offsetY );
        //
        // console.log('         x: ' + x + ', y: ' + y);
        // console.log('  norm - x: ' + normX.toFixed(2) + ', y: ' + normY.toFixed(2));
        // console.log('coords - x: ' + coords.x.toFixed(2) + ', y: ' + coords.y.toFixed(2));

        // var intersects = raycaster.intersectObjects(objects, recursiveFlag)
        const intersects = raycaster.intersectObjects(hits, true)

        if (intersects.length > 0) {
            const first = intersects[0]
            let hitObject // the parent hitObject groups path and ball objects

            if (first.object) {
                const metadata = first.object.userData

                hitObject = first.object.parent

                if (metadata) {
                    // var game = metadata.game,
                    const play = metadata.playId

                    // if (game && play && play !== playId) {
                    if (play && play !== playId) {
                        playId = play
                        cb && cb(metadata, hitObject, hits)
                    }
                }
            } else {
                playId = null
                cb && cb(null)
            }
        } else if (playId) {
            playId = null
            cb && cb(null)
        }
    }

    canvasEl.addEventListener('mousemove', pick)
}

Picker.prototype.enabled = function (enabled) {
    this.state.enabled = enabled
}

export default Picker
